import { IamPort } from './ProfileViewModel'
import Member from 'iam/models/Member'
import Role from 'iam/models/Role'
import { computed, makeObservable } from 'mobx'
import { SelectionViewModelPort } from './SelectionViewModel'
import { AlertFactory } from 'alerts/Alert'
import { CursorPaged, Id } from 'types/definitions'

export default class RolesSelectionViewModelAdapter
  implements SelectionViewModelPort<Role>
{
  constructor(
    public newAlert: AlertFactory,
    private member: Member,
    private iamPort: IamPort,
  ) {
    makeObservable(this)
  }

  getItemId(item: Role): string {
    return Id.assert(item.id)
  }

  @computed
  get selection(): Role[] {
    return this.member.roles
  }

  async fetch(): Promise<CursorPaged<Role>> {
    return {
      cursor: null,
      data: await this.iamPort.fetchRoles(this.member.workspace),
    }
  }

  add(item: Role): Promise<unknown> {
    return this.iamPort.addRole(
      Id.assert(this.member.workspace.id),
      Id.assert(this.member.user.publicId),
      Id.assert(item.id),
    )
  }

  remove(item: Role): Promise<unknown> {
    return this.iamPort.removeRole(this.member, item)
  }

  getTextSearchValues(item: Role) {
    return [item.name, item.description]
  }

  canUpdate(item: Role) {
    // Can't change owner role for yourself.
    return item.isOwnerRole === false || !this.member.isCurrentUser
  }
}
